<template>
  <div class="grid grid-cols-2 gap-4 h-screen w-full p-4">
    <div class="flex flex-col items-center justify-center gap-2">
      <h2 class="text-2xl font-bold">Iconoir</h2>
      <!-- ICONOIR -->
      <!-- Usage: Prefix icon names with 'Iconoir' (e.g., 'IconoirPeaceHand') -->
      <BaseIcon name="IconoirPeaceHand" class="text-red-500 h-20 w-20" />
    </div>
    <div class="flex flex-col items-center justify-center gap-2">
      <h2 class="text-2xl font-bold">Heroicons</h2>
      <!-- HEROICONS -->
      <!-- Usage: Prefix icon names with 'Hero' and Solid or Outline (e.g., 'HeroAdjustmentsVerticalIconSolid' / 'HeroAdjustmentsVerticalIconOutline') -->
      <BaseIcon name="HeroAdjustmentsVerticalIconSolid" class="text-red-500 h-20 w-20" />
    </div>
  </div>
</template>
